import './App.css';
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import './Pages/FormContact.js';
import Contact from './Pages/Contact.js';
import Description from './Pages/Description.js';
import Banner from './Pages/Banner.js';
import Footer from './Pages/Footer.js';
import Team from './Pages/Team.js';
import MyParticles from './Pages/Particles/MyParticles.js';

function App() {
  return (
    <>
    <Banner></Banner>   
    <div id='container'>
      <Routes>
        <Route path="/" exact element={<Description/>} />
        {/* <Route path="/services" element={<Services/>} /> */}
        <Route path="/contact" element={<Contact/>} />
        <Route path="/team" element={<Team/>} />
        {/* <Route path="/cards" element={<CardsTest/>} /> */}
         <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      
    </div>
    <div className='particles-container'>
      <MyParticles></MyParticles>
    </div>
    <Footer></Footer>
    </>
    
  );
}

export default App;
